import { render, staticRenderFns } from "./firebase_register_component.vue?vue&type=template&id=4e129d7e&scoped=true"
import script from "./firebase_register_component.vue?vue&type=script&lang=js"
export * from "./firebase_register_component.vue?vue&type=script&lang=js"
import style0 from "./firebase_register_component.vue?vue&type=style&index=0&id=4e129d7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e129d7e",
  null
  
)

export default component.exports